<template>
  <div :class="['project-search', uiType]">
    <input
      type="text"
      maxlength="20"
      placeholder="请输入楼盘名称，开始找房"
      v-model="searchValue"
      @focus="searchChange"
      @input="searchChange"
      @blur="searchdBlur"
      @keyup.enter="goNewHouse"
    />

    <el-button type="text" class="submit" @click="goNewHouse"><i v-if="uiType==='max'" class="el-icon-search"></i>开始找房</el-button>
    <div class="project-list-box" v-if="projectList && projectList.length > 0">
      <ul class="project-list">
        <li class="project-item" v-for="(item, index) in projectList" :key="index" @click="goProjectItem(item)">
          <span class="project-item-name">{{item.projectName}}</span>
          <span class="project-item-price">{{ projectPrice(item) }}{{ projectPriceUnit(item) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProjectSearch',
  props: {
    fromPage: {
      type: String,
      default: ''
    },
    uiType: {
      type: String,
      default: 'min'
    },
  },
  data () {
    return {
      timer: null,
      searchValue: '',
      projectList:  [],
      projectListShow: false
    }
  },
  computed: {
    ...mapGetters([
      'homePage',
    ]),

  },
  created() {
    if (this.fromPage === 'newHouse') {
      const query = this.$route.query
      this.searchValue = query && query.searchValue
    }
  },
  methods: {
    // 获取项目列表
    getProjectList(projectName){
      const baseParams = {
        projectName,
        districtIdList: [],
        roomStructure: [],
        priceRanges: [],
        displayPriceType: 2,
        sortType: '',
        homePageId: this.homePage.id,
      }
      const params = { queryString: JSON.stringify(baseParams)}
      this.$api.getProjectList(params).then(res => {
        this.projectList = res.data || []
      })
    },
    searchChange(){
      if(this.searchValue && this.searchValue.replace(/\s+/g, "") !== ''){
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.getProjectList(this.searchValue)
        }, 200);
      }
    },
    searchdBlur(){
      setTimeout(() => {
        this.projectList = []
      }, 500);
    },
    projectPrice (projectInfo) {
      let {
        averagePrice, averagePriceUnit, displayPriceType,
        lowestTotalPrice, topTotalPrice, totalPriceUnit,
      } = projectInfo
      averagePrice = averagePrice || '--'
      lowestTotalPrice = lowestTotalPrice || '-'
      topTotalPrice = topTotalPrice || '-'
      const totalType = `${lowestTotalPrice}-${topTotalPrice}`
      const averageType = `${averagePrice}`
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '价格待定': totalType
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '价格待定': averageType
      }
    },
    projectPriceUnit  (projectInfo) {
      let { averagePriceUnit,  totalPriceUnit, displayPriceType } = projectInfo
      averagePriceUnit = averagePriceUnit || '均价（元/平）'
      totalPriceUnit = totalPriceUnit || '万元/套'
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '': totalPriceUnit
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '': averagePriceUnit
      }
    },
    // 开始找房
    goNewHouse(){
      if (this.fromPage === 'newHouse') {
        this.$emit('getProjectList', { searchValue: this.searchValue} )
      } else {
        this.projectList = []
        const searchValue = this.searchValue.replace(/\s+/g, "") || ''
        if (searchValue) {
          this.$router.push({ path: '/newHouse', query:{searchValue}})
        } else {
          this.$router.push({ path: '/newHouse' })
        }
      }
    },
    // 跳转项目详情
    goProjectItem(item){
      if (this.fromPage === 'projectDetail') {
        this.$emit('getProjectCode', item.projectCode)
        this.searchValue = ''
      } else {
        this.$router.push({ path: '/ProjectDetail', query:{projectCode: item.projectCode } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.project-search{
  width: 1180px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  position: relative;
  &.max{
    width: 1180px;
    input{
      width: 80%;
    }
    .submit{
      width: 20%;
    }
    .project-list-box{
      width: 1180px;
    }
  }
  input{
    width: 88%;
    border: none;
    height: 50px;
    box-sizing: border-box;
    padding: 0 10px 0 20px;
    background:#f9fafa;
    font-size: 16px;
    color: #333333;
    font-family: MicrosoftYaHei;
    border-radius: 4px;
    &::-webkit-input-placeholder {
      color: #9399A5;
    }
  }
  .submit{
    width: 12%;
    height: 50px;
    background: #BDA26C;
    border-radius: 0px 4px 4px 0px;
    font-size: 14px;
    color: #FFFFFF;
    .el-icon-search {
      font-size: 16px;
      font-weight: 700;
      padding-right: 10px;
      vertical-align: -1px;
    }

  }
  .project-list-box{
    position: absolute;
    left: 0;
    top: 50px;
    z-index: 100;
    width: 680px;
    height: auto;
    background: #FFFFFF;
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 10%);
    z-index: 9;
    .project-list{
      max-height: 285px;
      overflow: scroll;
      .project-item{
        cursor: pointer;
        padding: 0 20px;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #333333;
        display: flex;
        justify-content: space-between;
        .project-item-price{
          color: #9399A5;
        }
        &:hover{
          background: #FFF0D3;
        }
      }
    }
  }
}
</style>
